import React from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../components/HomeComponents/HeroSection";
// import Activities from '../components/HomeComponents/Activities';
import Demo from "../components/HomeComponents/Demo";
import Advantages from "../components/HomeComponents/Advantages";
import Roadmap from "../components/HomeComponents/Roadmap";
import Testimonials from "../components/HomeComponents/Testimonials";
import GettingStarted from "../components/HomeComponents/GettingStarted";
function Home() {
  return (
    <div>
      <Helmet>
        <title>
        Strawket – Smart Learning Platform for Educators & Students
        </title>
        <meta
          name="description"
          content="Strawket offers AI-powered tools for educators: live classes, automated attendance, quizzes, curriculum planning, and performance tracking."
        />
        <meta
          name="keywords"
          content="Strawket, student learning platform, demo classes, live sessions, education, student development, online learning, personalized education"
        />
        <link rel="canonical" href="https://strawket.com/" />

        {/* Open Graph (Facebook, LinkedIn, WhatsApp) */}
        <meta
          property="og:title"
          content="Strawket – Discover the Best Learning Academies Online"
        />
        <meta
          property="og:description"
          content="Strawket helps students find and connect with top-rated learning institutes. Explore trusted academies for academics, hobbies, and skills."
        />
        <meta property="og:url" content="https://strawket.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://strawket.com/static/media/logo.18f8cc4a64e05c1ba825.png"
        />
        <meta property="og:site_name" content="Strawket" />

        {/* Twitter Card (X) */}
        <meta
          name="twitter:title"
          content="Strawket | Learn Smarter with Demo Classes & Live Sessions"
        />
        <meta
          name="twitter:description"
          content="Join Strawket to access personalized demo classes, expert-led learning, and build your academic journey."
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://www.strawket.com/assets/images/strawket-social-preview.png"
        />
      </Helmet>

      <HeroSection />
      {/* <Activities /> */}
      <Demo />
      <Advantages />
      <Roadmap />
      <Testimonials role="home" />
      <GettingStarted />
    </div>
  );
}

export default Home;
